/* MiniMondes — panier (drawer + page) : progression livraison offerte, upsells carrousel, offre garantie */
(function () {
  var SEUIL = 6900; // centimes
  var MAX_UPSELLS = 6;
  var GAR_HANDLE = 'garantie-serenite';
  var css = '' +
    '.mm-ship{margin:0 0 14px;padding:12px 14px;background:#FBF8F3;border-radius:14px;font-family:inherit}' +
    '.mm-ship-txt{font-size:.88rem;font-weight:600;color:#4A4038;margin:0 0 8px}' +
    '.mm-ship-txt strong{color:#C9785B}' +
    '.mm-ship.done .mm-ship-txt strong{color:#6E8B5E}' +
    '.mm-ship-bar{height:8px;background:#EFE6DA;border-radius:99px;overflow:hidden}' +
    '.mm-ship-bar .mm-ship-fill{display:block;height:100%;background:#C9785B;border-radius:99px;transition:width .4s ease}' +
    '.mm-ship.done .mm-ship-fill{background:#9DB089}' +
    '.mm-cup{margin:14px 0 4px;padding:12px 0 2px;border-top:1px solid rgba(74,64,56,.12)}' +
    '.mm-cup-t{font-size:.85rem;font-weight:700;color:#4A4038;margin:0 0 10px}' +
    '.mm-cup-list{display:flex;flex-direction:row;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:2px 2px 8px;scrollbar-width:thin}' +
    '.mm-cup-item{flex:0 0 132px;display:flex;flex-direction:column;align-items:center;text-align:center;gap:6px;background:#FBF8F3;border-radius:12px;padding:10px 8px;scroll-snap-align:start}' +
    '.mm-cup-item img{width:58px;height:58px;border-radius:10px;object-fit:cover;background:#fff;flex:none}' +
    '.mm-cup-info{min-width:0;width:100%}' +
    '.mm-cup-name{font-size:.72rem;font-weight:600;color:#4A4038;margin:0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;line-height:1.2}' +
    '.mm-cup-price{font-size:.72rem;color:#8a7f78;margin:2px 0 0}' +
    '.mm-cup-add{flex:none;border:0;cursor:pointer;background:#C9785B;color:#fff;font-weight:700;font-size:.74rem;padding:6px 12px;border-radius:99px;font-family:inherit}' +
    '.mm-cup-add:disabled{opacity:.55;cursor:default}' +
    '.mm-gar{margin:14px 0 6px;border:2px dashed #6E8B5E;background:#EFF3EA;border-radius:16px;padding:16px 14px;display:flex;gap:12px;align-items:center}' +
    '.mm-gar-ic{flex:none;width:54px;height:54px;border-radius:12px;background:#DDE8D4;display:grid;place-items:center;color:#4C6B3C}' +
    '.mm-gar-ic svg{width:30px;height:30px}' +
    '.mm-gar-info{flex:1;min-width:0}' +
    '.mm-gar-lbl{font-size:.72rem;font-weight:800;letter-spacing:.6px;text-transform:uppercase;color:#4C6B3C;margin:0}' +
    '.mm-gar-t{font-size:.95rem;font-weight:700;color:#4A4038;margin:3px 0;line-height:1.25}' +
    '.mm-gar-s{font-size:.8rem;color:#5d564f;margin:0;line-height:1.35}' +
    '.mm-gar-add{flex:none;border:0;cursor:pointer;background:#6E8B5E;color:#fff;font-weight:800;font-size:.85rem;padding:11px 16px;border-radius:99px;font-family:inherit;white-space:nowrap}' +
    '.mm-gar-add:disabled{opacity:.55;cursor:default}';
  var garCache = null;

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var euros = function (cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  var busy = false;
  var recosCache = null;
  var recosForProduct = null;

  // — zones : tiroir latéral + page panier
  function zones() {
    var z = [];
    var d = document.querySelector('cart-drawer');
    if (d) {
      z.push({
        items: d.querySelector('cart-drawer-items'),
        chk: d.querySelector('#CartDrawer-Checkout, button[name="checkout"]')
      });
    }
    var pageItems = document.querySelector('cart-items');
    if (pageItems && !pageItems.closest('cart-drawer')) {
      var pageChk = document.querySelector('#checkout, .cart__footer button[name="checkout"]');
      z.push({ items: pageItems, chk: (pageChk && !pageChk.closest('cart-drawer')) ? pageChk : null, page: true });
    }
    return z;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function fetchRecos(productId, cartHandles) {
    if (recosCache && recosForProduct === productId) return Promise.resolve(recosCache);
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=10&intent=complementary';
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        if (!d.products || !d.products.length) {
          return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
            .then(function (r2) { return r2.ok ? r2.json() : { products: [] }; });
        }
        return d;
      })
      .then(function (d) {
        var list = (d.products || []).filter(function (p) {
          return p.available && cartHandles.indexOf(p.handle) === -1 && p.handle !== GAR_HANDLE;
        }).slice(0, MAX_UPSELLS);
        recosCache = list; recosForProduct = productId;
        return list;
      })
      .catch(function () { return []; });
  }

  function refreshDrawerSections() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var tmp = document.createElement('div');
        if (sections['cart-drawer']) {
          tmp.innerHTML = sections['cart-drawer'];
          var fresh = tmp.querySelector('#CartDrawer');
          var cur = document.querySelector('#CartDrawer');
          if (fresh && cur) {
            var wasOpen = document.querySelector('cart-drawer').classList.contains('active');
            cur.innerHTML = fresh.innerHTML;
            if (wasOpen) document.querySelector('cart-drawer').classList.add('active');
          }
        }
        if (sections['cart-icon-bubble']) {
          tmp.innerHTML = sections['cart-icon-bubble'];
          var bub = document.querySelector('#cart-icon-bubble');
          if (bub) bub.innerHTML = tmp.querySelector('.shopify-section') ? tmp.querySelector('.shopify-section').innerHTML : tmp.innerHTML;
        }
      });
  }

  function onCartPage() {
    var pi = document.querySelector('cart-items');
    return pi && !pi.closest('cart-drawer') && !document.querySelector('cart-drawer.active');
  }

  function addToCart(variantId, btn, label) {
    if (busy) return;
    busy = true;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        if (onCartPage()) { window.location.reload(); return; }
        return refreshDrawerSections();
      })
      .then(function () { busy = false; scheduleUpdate(); })
      .catch(function () {
        busy = false;
        btn.disabled = false;
        btn.textContent = label || '+ Ajouter';
      });
  }

  function findSibling(el, cls, dir) {
    var n = dir === 'prev' ? el.previousElementSibling : el.nextElementSibling;
    while (n) {
      if (n.classList && n.classList.contains(cls)) return n;
      n = dir === 'prev' ? n.previousElementSibling : n.nextElementSibling;
    }
    return null;
  }

  function renderZone(cart, z) {
    if (!z.items) { renderGarantie(cart, z); return; }
    var parent = z.items.parentNode;

    var oldShip = findSibling(z.items, 'mm-ship', 'prev');
    var oldCup = findSibling(z.items, 'mm-cup', 'next');

    if (!cart.items.length) {
      if (oldShip) oldShip.remove();
      if (oldCup) oldCup.remove();
      renderGarantie(cart, z);
      return;
    }

    // barre de progression
    var total = cart.total_price;
    var pct = Math.min(100, Math.round(total * 100 / SEUIL));
    var txt = (total >= SEUIL)
      ? '🎉 <strong>Livraison offerte</strong> sur votre commande !'
      : 'Plus que <strong>' + euros(SEUIL - total) + '</strong> pour la <strong>livraison offerte</strong> 🚚';
    var wrap = oldShip;
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'mm-ship';
      wrap.innerHTML = '<p class="mm-ship-txt"></p><div class="mm-ship-bar"><div class="mm-ship-fill" style="width:0%"></div></div>';
      parent.insertBefore(wrap, z.items);
    }
    wrap.classList.toggle('done', total >= SEUIL);
    wrap.querySelector('.mm-ship-txt').innerHTML = txt;
    var fill = wrap.querySelector('.mm-ship-fill');
    void fill.offsetWidth;
    fill.style.width = pct + '%';

    // upsells (carrousel horizontal)
    var firstId = cart.items[0].product_id;
    var handles = cart.items.map(function (i) { return i.handle; });
    fetchRecos(firstId, handles).then(function (recos) {
      var oc = findSibling(z.items, 'mm-cup', 'next');
      var sig = recos.map(function (p) { return p.handle; }).join(',');
      if (oc && oc.dataset.sig === sig) return;
      if (oc) oc.remove();
      if (!recos.length) return;
      var cup = document.createElement('div');
      cup.className = 'mm-cup';
      cup.dataset.sig = sig;
      var title = (cart.total_price < SEUIL) ? 'Complétez pour la livraison offerte :' : 'Pour compléter :';
      var html = '<p class="mm-cup-t">' + title + '</p><div class="mm-cup-list">';
      recos.forEach(function (p) {
        var v = null;
        for (var k = 0; k < p.variants.length; k++) { if (p.variants[k].available) { v = p.variants[k]; break; } }
        if (!v) return;
        var img = p.featured_image ? p.featured_image + '&width=140' : '';
        if (img.indexOf('?') === -1) img = img.replace('&width=140', '?width=140');
        var name = p.title.split('—')[0].split('–')[0].trim();
        html += '<div class="mm-cup-item">' +
          (img ? '<img src="' + img + '" alt="">' : '') +
          '<div class="mm-cup-info"><p class="mm-cup-name">' + name + '</p>' +
          '<p class="mm-cup-price">' + euros(v.price) + '</p></div>' +
          '<button type="button" class="mm-cup-add" data-vid="' + v.id + '">+ Ajouter</button></div>';
      });
      html += '</div>';
      cup.innerHTML = html;
      z.items.insertAdjacentElement('afterend', cup);
      cup.querySelectorAll('.mm-cup-add').forEach(function (b) {
        b.addEventListener('click', function () { addToCart(parseInt(b.dataset.vid, 10), b, '+ Ajouter'); });
      });
    });

    renderGarantie(cart, z);
  }

  function renderGarantie(cart, z) {
    if (!z.chk || !z.chk.isConnected) return;
    var host = z.chk.closest('.cart__ctas') || z.chk;
    var old = findSibling(host, 'mm-gar', 'prev');
    var inCart = cart.items.some(function (i) { return i.handle === GAR_HANDLE; });
    if (!cart.items.length || inCart) { if (old) old.remove(); return; }
    if (old) return;
    var p = garCache ? Promise.resolve(garCache) : fetch('/products/' + GAR_HANDLE + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (x) { garCache = x; return x; });
    p.then(function (prod) {
      var v = prod.variants && prod.variants[0];
      if (!v || !v.available) return;
      if (!host.parentNode || findSibling(host, 'mm-gar', 'prev')) return;
      var box = document.createElement('div');
      box.className = 'mm-gar';
      box.innerHTML = '<span class="mm-gar-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.6-3 7.7-7 9-4-1.3-7-4.4-7-9V6z"/><path d="M9 11.5l2 2 4-4"/></svg></span>' +
        '<span class="mm-gar-info"><p class="mm-gar-lbl">Offre unique</p>' +
        '<p class="mm-gar-t">Garantie Sérénité — ' + euros(v.price) + '</p>' +
        '<p class="mm-gar-s">Colis perdu ou cassé : remplacé. + 15 % offerts sur votre prochaine commande.</p></span>' +
        '<button type="button" class="mm-gar-add" data-vid="' + v.id + '">+ AJOUTER</button>';
      host.parentNode.insertBefore(box, host);
      box.querySelector('.mm-gar-add').addEventListener('click', function () {
        addToCart(v.id, box.querySelector('.mm-gar-add'), '+ AJOUTER');
      });
    }).catch(function () {});
  }

  function render(cart) {
    zones().forEach(function (z) { renderZone(cart, z); });
  }

  var t = null;
  function scheduleUpdate() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetchCart().then(render).catch(function () {});
    }, 250);
  }

  function init() {
    // icône panier du header -> page /cart (au lieu d'ouvrir le tiroir)
    document.addEventListener('click', function (e) {
      var ic = e.target.closest && e.target.closest('#cart-icon-bubble');
      if (ic) { e.preventDefault(); e.stopPropagation(); window.location.href = '/cart'; }
    }, true);
    var targets = [];
    var d = document.querySelector('cart-drawer');
    if (d) targets.push(d);
    var pi = document.querySelector('cart-items');
    if (pi && !pi.closest('cart-drawer')) {
      var sec = pi.closest('.shopify-section') || pi;
      targets.push(sec);
      var foot = document.querySelector('.cart__footer');
      if (foot) { var fs = foot.closest('.shopify-section') || foot; if (targets.indexOf(fs) === -1) targets.push(fs); }
    }
    if (!targets.length) return;
    var isOurs = function (n) {
      return n.nodeType === 1 && ((n.matches && n.matches('.mm-ship,.mm-cup,.mm-gar')) || (n.closest && n.closest('.mm-ship,.mm-cup,.mm-gar')));
    };
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var tgt = m.target;
        if (tgt.closest && tgt.closest('.mm-ship,.mm-cup,.mm-gar')) continue;
        if (m.type === 'childList') {
          var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
          var external = false;
          for (var j = 0; j < nodes.length; j++) { if (!isOurs(nodes[j])) { external = true; break; } }
          if (!external) continue;
        }
        scheduleUpdate();
        return;
      }
    });
    targets.forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    scheduleUpdate();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
